export default "__VITE_PUBLIC_ASSET__0965fe26__"